import type { GenericRecord } from 'services/utils';

import type { Deviation, DeviationsFieldV2, VehicleV2 } from 'API';

export const getVehicleByVin = (vehicleData: GenericRecord<VehicleV2> | undefined, vin: VehicleV2['vin']) =>
    vehicleData?.[vin];

export const getVehicleIdentifier = (vehicle: VehicleV2) =>
    vehicle.name || vehicle.licensePlate || vehicle.vin.slice(-7);

/**
 * Flattens the V2 deviations field array into a list of plain Deviation objects,
 * discarding null entries and field wrappers. Lets existing helpers (setSeverity,
 * getOldestDeviation, findMostPrioSeverity) keep operating on Deviation[].
 */
export const flattenV2Deviations = (deviations?: (DeviationsFieldV2 | null)[] | null): Deviation[] =>
    deviations?.map(_ => _?.value?.deviation).filter((_): _ is Deviation => !!_) ?? [];
